// extracted by mini-css-extract-plugin
export default {"headerItem":"FloButtonTabs_headerItem__+A5Zc","isActive":"FloButtonTabs_isActive__ZNEaz"};